<template>
  <div class="noResult-warp">
    <div class="noResult-box">
      <img src="//project-homedo.oss-cn-shanghai.aliyuncs.com/2518fb62-761f-4a4e-8c48-10708be111cc_no-sol-data.png">
      <div class="noResult-tip">没有找到相关{{noResultData.typeName}}</div>
      <div class="noResult-link" @click="toList">随便看看</div>
    </div>
  </div>
</template>

<script>
import noResultImg from '@/assets/images/image_chazhao.png'
export default {
  name: 'noResult',
  props: ['noResultData'],
  data () {
    return {
      noResultImg
    }
  },
  methods: {
    toList () {
      this.$emit('toListSelf', true)
    }
  }
}
</script>

<style scoped lang="scss">
  .noResult-warp {
    width: 100%;
    height: calc(100vh - 90px);
    text-align: center;
    img {
      width: 160px;
      width: 160px;
      margin-top: 50px;
    }
    .noResult-tip {
      font-size: 15px;
      color: rgba(0,0,0,0.65);
      margin-top: 24px;
    }
    .noResult-link {
      width: 200px;
      height: 44px;
      margin: 40px auto 0;
      border-radius: 5px;
      background-color: #2F7BFF;
      text-align: center;
      line-height: 44px;
      color: #fff;
      font-size: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/noResult.vue